module.exports = __webpack_public_path__ + "static/media/field02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/fields/field02.svg
// module id = 65
// module chunks = 0